import styled from 'styled-components';

const Wrapper = styled.div`
  h4 {
    padding-bottom: 10px;
  }
`;

export default { Wrapper };
